// Gesture support.
import 'hammerjs';
import '~core/rxjs-extentsions';
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
